function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/*
 * Copyright (c) 2015 - 2023 by KAA Soft. All rights reserved.
 */

import { adminConfig } from "../adminConfig";
import { httpRequest } from "./httpRequest";
import { bookCopyBorrowingStatus, bookCopyLostStatus, getFlexDataBookTemplate } from "./book";
var selectLoadingTemplate = '<div class="d-flex justify-content-center"><div class="bounce-spinner"><div class="bounce-1"></div><div class="bounce-2"></div><div class="bounce-3"></div></div></div>';
function getSelectConfig(element) {
  if (!element instanceof HTMLElement) return;
  if (!element) return;
  var config = {
    plugins: {
      'dropdown_input': true
    },
    render: {}
  };
  config.create = element.dataset.create === 'true';
  if (element.dataset.rb === 'true') {
    config.plugins.remove_button = true;
  }
  if (element.dataset.cb === 'true') {
    config.plugins.clear_button = true;
  }
  return config;
}

/**
 * @property {string} firstName
 * @property {string} lastName
 * @property {array} bookCopies
 * @property {string} webPath
 * @external TomSelect
 */
export function remoteSearchSelectInit(elementId) {
  var element = document.getElementById(elementId);
  if (!element) return;
  var config = getSelectConfig(element);
  var label;
  var searchType = element.dataset.type;
  var route = element.dataset.route;
  if (!route) return console.warn(adminConfig.messages.routeNotSpecified);
  if (!searchType) return console.warn(adminConfig.messages.selectSearchTypeNotSpecified);
  var itemType = element.dataset.item ? element.dataset.item : 'simple';
  config.load = function (query, callback) {
    var params = new URLSearchParams({
      searchText: query
    });
    httpRequest({
      url: route,
      data: params
    }).then(function (response) {
      if (response && response.data && !response.data.error) {
        var responseItems = response.data[searchType].map(function (item) {
          if (searchType === 'users') {
            label = (item.firstName ? item.firstName + ' ' : '') + (item.lastName ? item.lastName : '') + (item.email ? ' (' + item.email + ')' : '');
          } else if (searchType === 'authors') {
            label = (item.firstName ? item.firstName + ' ' : '') + (item.lastName ? item.lastName : '');
          } else if (searchType === 'books' || searchType === 'pages' || searchType === 'posts') {
            label = item.title;
          } else {
            label = item.name;
          }
          var responseItem = {
            text: label,
            value: item.id
          };
          // console.info('responseItem1', responseItem)
          if (searchType === 'books') {
            responseItem = _extends({}, responseItem, {
              id: item.id,
              title: item.title,
              publisher: item.publisher ? item.publisher : '',
              authors: item.authors ? item.authors : '',
              genres: item.genres ? item.genres : '',
              copies: item.bookCopies ? item.bookCopies : '',
              publishingYear: item.publishingYear ? item.publishingYear : '',
              cover: item.cover ? item.cover : '',
              ISBN: item.ISBN ? item.ISBN : '',
              description: item.description
            });
            adminConfig.bookCopies['book-' + item.id] = responseItem;
          }
          if (searchType === 'users') {
            responseItem = _extends({}, responseItem, {
              name: (item.firstName ? item.firstName + ' ' : '') + (item.lastName ? item.lastName : ''),
              email: item.email
            });
            adminConfig.users['user-' + item.id] = responseItem;
          }
          // adminConfig.selects[elementId].clearOptions();
          return responseItem;
        });
        // console.info(responseItems);
        callback(responseItems);
      }
    });
  };
  if (searchType === 'books') {
    // config.valueField = 'id';
    // config.labelField = 'title';
    config.searchField = ['text', 'title', 'description'];
    config.highlight = false;
    config.render.item = function (data, escape) {
      if (itemType === 'simple') {
        return '<div>' + escape(data.text) + '</div>';
      }
      return selectBookTemplate(data, escape);
    };
    config.render.option = function (data, escape) {
      return selectBookTemplate(data, escape);
    };
  }
  config.render.loading = function () {
    return selectLoadingTemplate;
  };

  // console.warn("config", config);
  // console.warn("adminConfig", adminConfig);
  adminConfig.selects[elementId] = new TomSelect('#' + elementId, config);
  // console.warn("adminConfig", adminConfig);

  if (searchType === 'books') {
    adminConfig.selects[elementId].on('load', function () {
      adminConfig.lazyLoad.update();
    });
  }

  // for users !!
  if (element.classList.contains('has-username')) {
    adminConfig.selects[elementId].on('change', function (value) {
      var usernameElementId = element.dataset.usernameElement;
      if (!usernameElementId) return console.warn(adminConfig.errors.containerId);
      var usernameElement = document.getElementById(usernameElementId);
      console.info(adminConfig.users['user-' + value]);
      usernameElement.textContent = adminConfig.users['user-' + value].name;
    });
  }
  // for users !!
  if (element.classList.contains('for-create-request')) {
    adminConfig.selects[elementId].on('change', function (value) {
      var requestUserNameContainer = document.getElementById('request-user-name');
      requestUserNameContainer.querySelector('span').textContent = adminConfig.users['user-' + value].name;
    });
  }
  // for books !!
  /**
   * @property {string} borrowingStatus
   */
  if (element.classList.contains('has-copies')) {
    adminConfig.selects[elementId].on('change', function (value) {
      var bookCopiesSelectId = element.dataset.copiesSelect;
      if (!bookCopiesSelectId) return console.warn(adminConfig.errors.containerId);
      var bookCopiesSelectElement = adminConfig.selects[bookCopiesSelectId];
      var bookCopies = adminConfig.bookCopies['book-' + value].copies;
      bookCopiesSelectElement.clear(true);
      bookCopiesSelectElement.clearOptions();
      if (bookCopies && bookCopies.length > 0) {
        bookCopies.forEach(function (item) {
          if (item.borrowingStatus !== bookCopyBorrowingStatus && item.borrowingStatus !== bookCopyLostStatus) {
            bookCopiesSelectElement.addOption({
              text: '#' + item.id + ' - ' + item.hash,
              value: item.id
            });
          }
        });
        var selectOtpLength = Object.keys(bookCopiesSelectElement.options).length;
        var selectOtpFirstId = Object.keys(bookCopiesSelectElement.options)[0];
        if (selectOtpLength > 0) {
          bookCopiesSelectElement.addItem(bookCopiesSelectElement.options[selectOtpFirstId].value);
        }
        if (selectOtpLength < 1) {
          bookCopiesSelectElement.addOption({
            text: i18n.gettext('Not Available'),
            value: 'NULL'
          });
          bookCopiesSelectElement.addItem('NULL');
        }
      } else {
        bookCopiesSelectElement.addOption({
          text: i18n.gettext('Not Available'),
          value: 'NULL'
        });
        bookCopiesSelectElement.addItem('NULL');
      }
    });
  }
}
function selectBookTemplate(data, escape) {
  // console.warn(data);
  // if (!data.title) return '<div>' + escape(data.text) + '</div>';
  // const book = data.customProperties;
  return getFlexDataBookTemplate(data, false, true, true, escape);
}
export function simpleSelectInit(elementId) {
  var element = document.getElementById(elementId);
  if (!element) return;
  var config = getSelectConfig(element);
  adminConfig.selects[elementId] = new TomSelect('#' + elementId, config);
}
export function treeSelectInit(elementId) {
  var element = document.getElementById(elementId);
  if (!element) return;
  var config = getSelectConfig(element);
  config.allowEmptyOption = true;
  config.plugins.clear_button = true;
  config.render = {
    item: function item(data, escape) {
      var string = data.text;
      string = string.replace(/\s\s+/g, ' ');
      return '<div>' + escape(string) + '</div>';
    }
  };
  adminConfig.selects[elementId] = new TomSelect('#' + elementId, config);
}
export function updateCustomSelectValue(searchSelectId, searchSelectOptionId, searchSelectOptionName) {
  var selectControl = adminConfig.selects[searchSelectId];
  selectControl.addOption({
    value: searchSelectOptionId,
    text: searchSelectOptionName
  });
  selectControl.addItem(searchSelectOptionId);
  selectControl.refreshOptions();
  selectControl.refreshItems();
}

// todo: remove
// export function subscriptionServiceSelect(elementId) {
// let config = {
// plugins: {
// dropdown_input: true,
// remove_button: true,
// clear_button: true
// },
// maxItems: 2,
// render: {
// option: function (data, escape) {
// return "<div data-code='" + escape(data.code) + "'>" + escape(data.text) + "</div>"
// },
// item: function (item) {
// return `<div data-code="${item.code}">${item.text}</div>`;
// }
// }
// }
// adminConfig.selects[elementId] = new TomSelect('#' + elementId, config);
// adminConfig.selects[elementId].on('change', function (value) {
// let LR_CODE = 4;
// let BP_CODE = 2;
// let BPOptionId = 0;
// let LROptionId = 0;
// for (const [key, val] of Object.entries(adminConfig.selects[elementId].options)) {
// if (parseInt(val.code) === LR_CODE) {
// LROptionId = val.value;
// }
// if (parseInt(val.code) === BP_CODE) {
// BPOptionId = val.value;
// }
// }
// let currentValue = value.slice();
// adminConfig.selects[elementId].clear(true);
// if (currentValue.includes(LROptionId)) {
// adminConfig.selects[elementId].addItem(LROptionId, true);
// adminConfig.selects[elementId].addItem(BPOptionId, true);
// } else {
// // нужное значениче всегда последнее
// adminConfig.selects[elementId].addItem(currentValue[currentValue.length - 1], true);
// }
// });
// }

// вынести в отдельный файл
export function customSelectsInit(containerElement) {
  if (containerElement === void 0) {
    containerElement = 'body';
  }
  var container;
  if (containerElement instanceof HTMLElement) {
    container = containerElement;
  } else {
    container = document.querySelector(containerElement);
  }
  // Remote Selects
  var remoteSearchSelectElements = container.querySelectorAll(".remote-search-select");
  for (var i = 0; i < remoteSearchSelectElements.length; i++) {
    remoteSearchSelectInit(remoteSearchSelectElements[i].id);
  }

  // Simple Selects
  var simpleSelectElements = container.querySelectorAll(".simple-select");
  for (var _i = 0; _i < simpleSelectElements.length; _i++) {
    simpleSelectInit(simpleSelectElements[_i].id);
  }

  // Tree Selects
  var treeSelectElements = container.querySelectorAll(".tree-select");
  for (var _i2 = 0; _i2 < treeSelectElements.length; _i2++) {
    treeSelectInit(treeSelectElements[_i2].id);
  }

  // Remote User Selects
  // let megaUserSearchElements = container.querySelectorAll(".remote-user-search-select");
  // for (let i = 0; i < megaUserSearchElements.length; i++) {
  // remoteUserSearchSelectInit(megaUserSearchElements[i].id);
  // }

  // Subscription Service Selects
  // let subscriptionSelectElements = container.querySelectorAll(".subscription-service-select");
  // for (let i = 0; i < subscriptionSelectElements.length; i++) {
  // subscriptionServiceSelect(subscriptionSelectElements[i].id);
  // }
}